import styled from 'styled-components';

export const Popup = styled.div`
  position: absolute;
  right: 1.6rem;
  bottom: 5rem;
  background-color: ${({ theme }) => theme.colors.background.main};
  border: 2px solid ${({ theme }) => theme.colors.border.main};
  border-radius: ${({ theme }) => theme.radius.small};
  padding: 3rem;
  max-width: 50rem;
  width: calc(100vw - 3.2rem);
  display: flex;
  flex-direction: column;
  gap: 2.4rem;
  z-index: 1000;
  box-shadow: ${({ theme }) => theme.boxShadow.light};
`;

export const DismissButton = styled.button`
  position: absolute;
  top: 1.6rem;
  right: 1.6rem;
  background: none;
  border: none;
  color: ${({ theme }) => theme.colors.grey[100]};
  cursor: pointer;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 2rem;
    height: 2rem;
  }

  &:hover {
    opacity: 0.8;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 1.4rem;
  padding-right: 3.4rem;
`;

export const WarningIcon = styled.div`
  color: ${({ theme }) => theme.colors.warning.main};
  font-size: 2.3rem;
`;

export const Title = styled.h2`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.large};
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;
  flex: 1;
`;

export const Description = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;
`;

export const Countdown = styled.p`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  line-height: normal;
  color: ${({ theme }) => theme.colors.text.main};
  margin: 0;

  span {
    color: ${({ theme }) => theme.colors.warning.main};
    font-weight: ${({ theme }) => theme.fonts.weight.bold};
  }
`;

export const Buttons = styled.div`
  display: flex;
  gap: 1.6rem;
  justify-content: flex-start;
`;
